/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { appPalette, appType, paletteCssVars, typePairCssVars } from '@sidekick/design-tokens';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

// Inject palette + type-pair tokens as CSS custom properties.
// Software Neutral is the app-shell palette per the brand brief.
const styleEl = document.createElement('style');
styleEl.textContent = `:root {\n${paletteCssVars(appPalette)}\n${typePairCssVars(appType)}\n}`;
document.head.appendChild(styleEl);

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
